export default "__VITE_ASSET__2be8a822__"